import MenuItem from '../menuItem'
import type { MenuSectionProps } from '../types'

const MenuSection = ({
  sectionName,
  sectionItems,
  selectedItem,
  community,
  setSelectedItem
}: MenuSectionProps) => {
  return (
    <div className='_mt-4'>
      <p className='_text-gray-900 _font-weight-bold _mb-2 _text-1'>{sectionName}</p>
      {sectionItems.map(
        (item) =>
          item.show && (
            <MenuItem
              item={item}
              community={community}
              selectedItem={selectedItem === item.step}
              setSelectedItem={setSelectedItem}
              key={item.name}
            />
          )
      )}
    </div>
  )
}

export default MenuSection
